export default {
  airtel: require('./airtel').default,
};
